import firebase from 'firebase';

const config = {
    apiKey: "AIzaSyAUvgCEk9Puib77NokkbjeKQnkNbDTL8Vw",
    authDomain: "anonymo.firebaseapp.com",
    databaseURL: "https://anonymo.firebaseio.com",
    projectId: "anonymo",
    storageBucket: "anonymo.appspot.com",
    messagingSenderId: "152915801313",
    appId: "1:152915801313:web:b7812497f4c91b91"
};

export const firebaseImpl = firebase.initializeApp(config);
export const firebaseAuth = firebase.auth();
export const firebaseDatabase = firebase.firestore();
export const firestorage = firebase.storage();